/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { evaluateDependencies } from './dependenciesEvaluate.generated';
import { createDeprecatedEval } from '../../factoriesAny.js';
export var evalDependencies = {
  evaluateDependencies: evaluateDependencies,
  createDeprecatedEval: createDeprecatedEval
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDeprecatedEval.generated.js
// module id = 1523
// module chunks = 0